import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function JournalPreview() {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    axios.get(`${API}/journal`).then((r) => setPosts(r.data)).catch(() => {});
  }, []);

  return (
    <section data-testid="section-journal" className="bg-bone py-24 md:py-40 border-t border-ink/10">
      <div className="w-full max-w-[90rem] mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-12 gap-8 items-end mb-16 reveal">
          <p className="label col-span-12 md:col-span-2">08 — Journal</p>
          <h2 className="display col-span-12 md:col-span-7 text-[9vw] md:text-6xl lg:text-[5rem] leading-[0.98] tracking-tighter">
            Notes from <span className="italic font-light">the studio.</span>
          </h2>
          <div className="col-span-12 md:col-span-3 md:justify-self-end">
            <Link to="/journal" data-testid="journal-view-all" className="inline-flex items-center gap-2 text-[12px] uppercase tracking-[0.22em] border-b border-ink pb-1 hover:text-rust hover:border-rust transition-colors">
              All journal entries →
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {posts.map((p, i) => (
            <article key={p.slug} data-testid={`journal-card-${p.slug}`} className={`reveal group ${i === 0 ? "md:col-span-2" : "md:col-span-1"}`}>
              <div className={`overflow-hidden ${i === 0 ? "aspect-[16/9]" : "aspect-[4/3]"}`}>
                <img src={p.cover} alt={p.title} className="w-full h-full object-cover transition-transform duration-[1400ms] group-hover:scale-105" />
              </div>
              <div className="mt-5 flex items-center gap-3">
                <span className="label">{p.category}</span>
                <span className="text-ink/30">·</span>
                <span className="label">{p.read_time}</span>
                <span className="text-ink/30">·</span>
                <span className="label">{new Date(p.date).toLocaleDateString("en-AU", { day: "numeric", month: "short", year: "numeric" })}</span>
              </div>
              <h3 className={`display mt-3 ${i === 0 ? "text-4xl md:text-5xl" : "text-2xl md:text-3xl"} leading-tight group-hover:text-rust transition-colors`}>
                {p.title}
              </h3>
              <p className="mt-3 text-base text-muted2 max-w-xl">{p.excerpt}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
